import { render, staticRenderFns } from "./UsersTablePage.vue?vue&type=template&id=42dd2e26&scoped=true"
import script from "./UsersTablePage.vue?vue&type=script&lang=js"
export * from "./UsersTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dd2e26",
  null
  
)

export default component.exports